import configureStore, { history } from './configure';

const store = configureStore();
export default store;
export { history };
